import React from "react";

interface ErrorSummaryProps {
    errors: Record<string, any>;
}

const parseErrors = (errDetails: any) => {
    return Object.values(errDetails);
};

const ErrorSummary: React.FC<ErrorSummaryProps> = (props: any) => {
    const { errors } = props;
    let errorMap: any = [];
    let allErrors: any = [];

    // Parse error object only if it has keys
    if (Object.keys(errors).length > 0) {
        errorMap = parseErrors(errors);
    }

    return (
        <>
            {errorMap.length > 0 && (
                <div className="error-summary card custom-card custom-card-new p-3">
                    <h2 className="error-message">
                        There were some errors in your form, please fix them to proceed with the onboarding process
                    </h2>
                    <ul>
                        {errorMap.map((err: any, index: number) => {
                            // Avoid duplicate error messages
                            if (!allErrors.includes(err)) {
                                allErrors.push(err);

                                let updatedErrorMsg = "";

                                // Case 1: Handle "_+_" pattern (custom split)
                                if (Array.isArray(err) && typeof err[0] === "string" && JSON.stringify(err?.[0]).includes("_+_")) {
                                    updatedErrorMsg = err?.[0]?.split("_+_")?.[1];
                                }

                                // Case 2: Handle "||" pattern (custom reordering)
                                if (Array.isArray(err) && typeof err[0] === "string" && updatedErrorMsg?.includes("||")) {
                                    const splitErrorMsg = updatedErrorMsg?.split("||");
                                    updatedErrorMsg = splitErrorMsg?.[1] + " " + splitErrorMsg?.[0];
                                }

                                // Remove quotes if any
                                updatedErrorMsg = updatedErrorMsg?.replace(/"/g, "");

                                return (
                                    <React.Fragment key={index}>
                                        {typeof err === "string" ? (
                                            <li className="error-message">{err}</li>
                                        ) : Array.isArray(err) && typeof err[0] === "string" && err[0]?.includes("_+_") ? (
                                            <li className="error-message">{updatedErrorMsg}</li>
                                        ) : (
                                            <li className="error-message">
                                                Make sure to fill all the above required fields and submit the necessary documents.
                                            </li>
                                        )}
                                    </React.Fragment>
                                );
                            }
                            return null;
                        })}
                    </ul>
                </div>
            )}
        </>
    );
};


export default ErrorSummary;
